import React from 'react';
import { Box, InputBase, Typography } from '@mui/material';
import SearchIcon from '../../../../assets/svg-fc/b2b/SearchIcon';
import LineChevronSvg from '../../../../assets/svg-fc/LineChevronSvg';
import './chatsHeader.scss';

interface ArchivedChatsHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
}

const ArchivedChatsHeader: React.FC<ArchivedChatsHeaderProps> = ({ searchTerm, onSearchChange, onBack }) => (
  <Box className="chatsHeader archivedChatsHeader">
    <Box className="archivedTitleRow">
      <Box component="button" type="button" aria-label="Back to messages" className="archivedBackButton" onClick={onBack}>
        <LineChevronSvg size={24} direction="left" />
      </Box>
      <Typography className="chatsTitle">Archived</Typography>
    </Box>
    <Box className="searchAndFilterRow">
      <Box className="searchContainer">
        <Box className="searchIcon">
          <SearchIcon />
        </Box>
        <InputBase
          placeholder="Search archived chats"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="searchInput"
        />
      </Box>
    </Box>
  </Box>
);

export default ArchivedChatsHeader;
